var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeactivateEmployee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.252,
    height: 14.252,
    viewBox: "0 0 14.252 14.252",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_145",
    "data-name": "Rechteck 145",
    width: 17.995,
    height: 2.159,
    transform: "translate(1.527) rotate(45)",
    fill: "#4b5960"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_146",
    "data-name": "Rechteck 146",
    width: 17.995,
    height: 2.159,
    transform: "translate(14.252 1.527) rotate(135)",
    fill: "#4b5960"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateEmployee);
export default __webpack_public_path__ + "static/media/deactivate_employee.e5b476482ac1cf2550c545bed837a3c4.svg";
export { ForwardRef as ReactComponent };